<template>
    <div class="c-mzl-subjects--rte" data-css="c-mzl-subjects">          
        <form class="mzl-subjects__form" action="" method="" data-css="c-form"  onsubmit="return false;" >
            <fieldset class="mzl-subjects__fieldset">             
                    <!-- Container 1 -->
                    <template v-if="containerSubjectsIsVisible">                     
                        <SubjectItem 
                            :title="this.text.teachingSubjectText" 
                            :subject="'didactics_subject1'" 
                            :selectOptionsSubject="this.selectOptionsSubject"
                            :optionSelector="'subject'"
                            :defaultOptionText="this.text.defaultOptionText"
                            @subjectSelected="getDependingSelection" />                        
                    </template>
                    <!-- Container 2 -->
                    <template v-if="containerDidactics1IsVisble">                 	
                            <SubjectItem :title="'1. ' + this.text.didaktikSubjectText"
                                :subject="'didactics_subject2'" 
                                :selectOptionsSubject="this.selectOptionsDidactics1"
                                :optionSelector="'didactics_subject1'"
                                :defaultOptionText="this.text.defaultOptionText"
                                @subjectSelected="getDependingSelection" />						
                    </template>
                    <!-- Container 3 -->
                    <template v-if="containerDidactics2IsVisble">                   
                            <SubjectItem :title="'2. ' + this.text.didaktikSubjectText"
                                :subject="'didactics_subject3'" 
                                :selectOptionsSubject="this.selectOptionsDidactics2"
                                :optionSelector="'didactics_subject2'"
                                :defaultOptionText="this.text.defaultOptionText"
                                @subjectSelected="getDependingSelection" />                   
                     </template>
                    <!-- Container 4 -->
                    <template v-if="containerDidactics3IsVisble">  
                        <SubjectItem :title="'3. ' + this.text.didaktikSubjectText"
                                :subject="'none'" 
                                :selectOptionsSubject="this.selectOptionsDidactics3"
                                :optionSelector="'didactics_subject3'"
                                :defaultOptionText="this.text.defaultOptionText"
                                @subjectSelected="getDependingSelection" />						
                    </template>
                        <!-- Anzeige Gewählte Fächerkombination: Definition List -->
                    <div v-if="showRestartButton" class="c-definition-list--default mzl-subjects__definition-list" data-css="c-definition-list">
                        <h3 class="definition-list__headline">{{ this.text.selectSubjectCombinationText }}</h3>
                        <dl class="definition-list__list">
                            <dt class="definition-list__title">{{ this.text.teachingSubjectText }}</dt>
                            <dd class="definition-list__description">{{ mzlSubjects.selectedSubject }}</dd>
                            <dt class="definition-list__title">1. {{ this.text.didaktikSubjectText }}</dt>
                            <dd class="definition-list__description">{{  mzlSubjects.selectedDidactics1 }}</dd>
                            <dt class="definition-list__title">2. {{ this.text.didaktikSubjectText }}</dt>
                            <dd class="definition-list__description">{{  mzlSubjects.selectedDidactics2 }}</dd>
                            <dt class="definition-list__title">3. {{ this.text.didaktikSubjectText }}</dt>
                            <dd class="definition-list__description">{{  mzlSubjects.selectedDidactics3 }}</dd>
                        </dl>
                    </div>                
                    <!-- Button Restart -->
                    <div>
                    <button v-if="showRestartButton" class="form__submit-ci" @click="resetAll">
                        <span class="form__submit-ci-text">{{ this.text.startAgainText }}</span>
                    </button>
                    </div>
            </fieldset>
        </form> 		
    </div>
</template>

<script>
import SubjectItem from './components/SubjectItem.vue';

export default {
    name: "FacetCombinatorApp",
    components: {
        SubjectItem
    },
    data() {
        return {
            dataSource: this.rootData.dataSource,                        
            selectOptionsSubject: [],
            selectOptionsDidactics1: [],
            selectOptionsDidactics2: [],
            selectOptionsDidactics3: [],
            containerSubjectsIsVisible: 1,
            containerDidactics1IsVisble: 0,
            containerDidactics2IsVisble: 0,
            containerDidactics3IsVisble: 0,
            showRestartButton: 0,
            items: [],
            text: this.rootData.text
        }
    },
    computed: {
        mzlSubjects() {
            return  {
                selectedSubject: "",
                selectedDidactics1: "",
                selectedDidactics2: "",
                selectedDidactics3: ""
            }
        }
    },
    mounted() {
        this.fetchData();
        console.log("dataSource: ", this.dataSource);
    },
    methods: {
        fetchData() {
            fetch(this.dataSource)
                .then(function (response) {
                    if (response.status !== 200) {
                        console.info('Could not fetch data. Status Code: ' + response.status);
                    }
                    return response.json()
                })
                .then((data) => {
                    this.items = data;
                    this.selectOptionsSubject = this.distinctValues(this.items, "subject");
                })
                .catch(function (err) {
                    console.log('Fetch Error :-S', err);
                })
        },              
        // get depending subject list for selected item
        getDependingSelection(selectedValue, subjectType) {
            const subject = this.mzlSubjects;            
            this.showNextSelection(subjectType);
            if (subjectType == "didactics_subject1") {
                subject.selectedSubject = selectedValue;
                this.selectOptionsDidactics1 = this.items.filter(function (currentObject) {
                    return currentObject.subject == selectedValue;
                })
                this.selectOptionsDidactics1 = this.distinctValues(this.selectOptionsDidactics1, "didactics_subject1");
            }
            else if (subjectType == "didactics_subject2") {                
                subject.selectedDidactics1 = selectedValue;
                this.selectOptionsDidactics2 = this.items.filter(function (currentObject) {
                    return currentObject.subject == subject.selectedSubject && currentObject.didactics_subject1 == selectedValue;
                });
                this.selectOptionsDidactics2 = this.distinctValues(this.selectOptionsDidactics2, "didactics_subject2");
            }
            else if (subjectType == "didactics_subject3") {                
                subject.selectedDidactics2 = selectedValue;
                this.selectOptionsDidactics3 = this.items.filter(function (currentObject) {
                    return currentObject.subject == subject.selectedSubject && currentObject.didactics_subject1 == subject.selectedDidactics1 && currentObject.didactics_subject2 == selectedValue;
                });
                this.selectOptionsDidactics3 = this.distinctValues(this.selectOptionsDidactics3, "didactics_subject3");
            }
            else {
                subject.selectedDidactics3 = selectedValue;
            }
        },
        // removes duplicated values
        distinctValues(items, key) {
            console.log("Distinct Values for key: ", key)
            return [...new Map(items.map(item =>
                [item[key], item])).values()];
        },
        // resets all options and selected options for all subsequent drop down lists and make next container visible
        showNextSelection(subjectType) {
            if (subjectType == "didactics_subject1") {
                this.selectOptionsDidactics1 = [];
                this.selectOptionsDidactics2 = [];
                this.selectOptionsDidactics3 = [];
                this.selectedDidactics1 = "";
                this.selectedDidactics2 = "";
                this.selectedDidactics3 = "";
                this.containerDidactics1IsVisble = 1;
                this.containerDidactics2IsVisble = 0;
                this.containerDidactics3IsVisble = 0;
            }
            if (subjectType == "didactics_subject2") {
                this.selectOptionsDidactics2 = [];
                this.selectOptionsDidactics3 = [];
                this.selectedDidactics2 = "";
                this.selectedDidactics3 = "";
                // this.containerDidactics1IsVisble = 1;
                this.containerDidactics2IsVisble = 1;
                this.containerDidactics3IsVisble = 0;
            }
            if (subjectType == "didactics_subject3") {
                this.selectedDidactics3 = "";
                this.containerDidactics3IsVisble = 1;
            }
            if (subjectType == "none") {
                this.showRestartButton = 1;
                this.containerSubjectsIsVisible = 0;
                this.containerDidactics1IsVisble = 0;
                this.containerDidactics2IsVisble = 0;
                this.containerDidactics3IsVisble = 0;
            }
        },
        resetAll() {
            console.log("reset all");
            this.showRestartButton = 0;
            this.containerSubjectsIsVisible = 1;
            this.containerDidactics1IsVisble = 0;
            this.containerDidactics2IsVisble = 0;
            this.containerDidactics3IsVisble = 0
            this.selectedSubject = "";
            this.selectedDidactics1 = "";
            this.selectedDidactics2 = "";
            this.selectedDidactics3 = "";
            this.selectOptionsSubject = this.distinctValues(this.items, "subject");
        }
    }
}
</script>